import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import HomePage from './pages/LandingPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import { webAppConfig } from './config/appConfig';

const setMetaByName = (name: string, content: string) => {
  const node = document.querySelector(`meta[name="${name}"]`);
  if (node) {
    node.setAttribute('content', content);
  }
};

const setMetaByProperty = (property: string, content: string) => {
  const node = document.querySelector(`meta[property="${property}"]`);
  if (node) {
    node.setAttribute('content', content);
  }
};

const applyRuntimeMetadata = () => {
  const { brand, seo } = webAppConfig;
  document.title = seo.title;
  setMetaByName('description', seo.description);
  setMetaByName('keywords', seo.keywords);
  setMetaByName('author', brand.name);
  setMetaByName('twitter:title', seo.title);
  setMetaByName('twitter:description', seo.description);
  setMetaByProperty('og:title', seo.title);
  setMetaByProperty('og:description', seo.description);

  const canonical = document.querySelector('link[rel="canonical"]');
  if (canonical) {
    canonical.setAttribute('href', seo.canonicalUrl);
  }
};

applyRuntimeMetadata();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to={webAppConfig.routes.home} replace />} />
        <Route path={webAppConfig.routes.home} element={<HomePage />} />
        <Route path={webAppConfig.routes.privacy} element={<PrivacyPage />} />
        <Route path={webAppConfig.routes.terms} element={<TermsPage />} />
        <Route path="/landing" element={<Navigate to={webAppConfig.routes.home} replace />} />
        <Route path={webAppConfig.routes.app} element={<App />} />
        <Route path="*" element={<Navigate to={webAppConfig.routes.home} replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
